import React, { useContext } from 'react';
import classes from '../index.module.scss';
import { SearchContext } from '../../../context/Search';
import { HashLink } from 'react-router-hash-link';
import { UserContext } from '../../../context/User';

const ContractingOfficerTableBody = () => {
  const { searchedData } = useContext(SearchContext);
  const { isLoggedIn } = useContext(UserContext);

  return (
    <>
      {
        searchedData.map(item => {
          const { name, id, office, user_id } = item;
          return (
            <tr 
              key={id}
            >
              <td className={`${classes.Title_Bold} ${classes.Vertical_Middle}`}>{name || "N/A"}</td>
              <td className={`${classes.Title_Normal} ${classes.Vertical_Middle}`}>{office || "N/A"}</td>
              <td className={classes.Table_Options}>
                <HashLink
                  to={isLoggedIn ? `/specific-message?id=${user_id}` : '/#basic-info'}
                  className="btnSizes filledBtn"
                >
                  Contact
                </HashLink>
                <HashLink
                  to={isLoggedIn ? `/contracting-officer?id=${id}` : '/#basic-info'}
                  className="btnSizes transparentBtn ml-4"
                  smooth
                >
                  View Profile
                </HashLink>
              </td>
            </tr>
          )
        })
      }
    </>
  )
}

export default ContractingOfficerTableBody;